import React from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

const Handle = ({ handle: { id, percent }, getHandleProps }) => (
  <div
    className={styles.handle}
    style={{
      left: `${percent}%`,
    }}
    {...getHandleProps(id)}
  />
);

Handle.propTypes = {
  handle: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    percent: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired,
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
};

export default Handle;
